import { SVGImagesProps } from "./svgTypes";

export const PauseIcon = ({ color }: SVGImagesProps) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4874 20.7297C6.3848 20.7241 2.24974 16.589 2.24414 11.4864V11.3016C2.34575 6.22196 6.528 2.17659 11.6082 2.24399C16.6883 2.3114 20.7618 6.46631 20.7286 11.5468C20.6954 16.6273 16.568 20.7286 11.4874 20.7297ZM11.4726 18.881H11.4874C15.5699 18.8769 18.8766 15.5652 18.8746 11.4827C18.8725 7.40025 15.5625 4.09183 11.48 4.09183C7.39751 4.09183 4.08744 7.40025 4.08539 11.4827C4.08335 15.5652 7.39012 18.8769 11.4726 18.881ZM14.2604 15.1837H12.4117V7.78913H14.2604V15.1837ZM10.5631 15.1837H8.71441V7.78913H10.5631V15.1837Z"
        fill={color}
      />
    </svg>
  );
};
